import React from "react";
import {Link} from "react-router-dom";
import {useSetting} from "../SettingsContext";
import ContactForm from "../components/ContactForm";

const Contact = () => {
    const setting = useSetting();
    return (
        <main>
            <section className="contact-banner-area" id="contact">
                <div className="container h-100">
                    <div className="contact-banner">
                        <div className="text-center">
                            <h1>Contact Us</h1>
                            <nav aria-label="breadcrumb" className="banner-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-margin">
                <div className="container">
                    <div className="row my-2">
                        <div className="col-md-4 col-lg-3 mb-4 mb-md-0">
                            <div className="media contact-info">
                                <span className="contact-info__icon"><i className="ti-home"></i></span>
                                <div className="media-body">
                                    <h3>{setting?.company_name}</h3>
                                    <p>{setting?.office_address}</p>
                                </div>
                            </div>
                            <div className="media contact-info">
                                <span className="contact-info__icon"><i className="ti-headphone"></i></span>
                                <div className="media-body">
                                    <h3>
                                        <a href={setting?.helpline}>{setting?.helpline}</a>
                                    </h3>
                                    <p>{setting?.office_hour}</p>
                                </div>
                            </div>
                            <div className="media contact-info">
                                <span className="contact-info__icon">
                                    <i className="ti-email"></i>
                                </span>
                                <div className="media-body">
                                    <h3><a href={setting?.contact_email}>{setting?.contact_email}</a></h3>
                                    <p>Send us your query anytime!</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <ContactForm />
                        </div>
                    </div>
                    <div className="d-sm-block mb-5 pb-4">
                        <iframe src={setting?.map}
                            width="100%" height="350" style={{border:0}} allowFullScreen="" loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Contact;